import { render } from "./user-standardtests.vue?vue&type=template&id=0097f332&ts=true"
import script from "./user-standardtests.vue?vue&type=script&lang=ts"
export * from "./user-standardtests.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__